<template>
  <div id="view-item">
    <page-title title="Nieuwsitem" description="Details van het nieuwsbericht"></page-title>
   

  <div class="row">  
      <button class="btn btn-light m-3" @click="$router.go(-1)">terug</button>
      <button class="btn btn-success m-3" @click="edit">bewerken</button>
      </div>

<div class="row" v-if="images.length>0">

<div class="col-md-4" v-for="image in images" :key=image.filename>
    <div class="thumbnail">
      <a :href="image.url">
        <img :src="image.url" alt="" style="width:100%">
        
      </a>
    </div>
</div>
</div>

    <div v-for="section in sections" :key="section.id">
      <h3>{{section.title}}</h3>
      <p>{{section.content}}</p>
    </div>
  </div>
</template>




<script>
import PageTitle from "@/components/PageTitle.vue";
const fb = require("@/firebaseConfig.js");
//const firestore = fb.firestore;
//const collection = fb.companiesCollection.doc(this.$cookies.get("company")).collection('information')

export default {
  name: "view-item",
  components: {
    PageTitle
  },
  data() {
    return {
      id: null,
      cid: null,
      images: [],
      sections: [],
      date_created: null,
      type: null,
      status: null,
      comments: []
    };
  },
  beforeRouteEnter(to, from, next) {
    fb.companiesCollection
      .doc(to.params.cid)
      .collection("information")
      .doc(to.params.id)
      .get()
      .then(doc => {
        console.log(doc.data());
        next(vm => {
          vm.id = doc.id;
          vm.images = doc.data().images ?? [] ;
          vm.sections = doc.data().sections;
          vm.date_created = doc.data().date_created;
          vm.type = doc.data().type;
          vm.status = doc.data().status;
          vm.comments = doc.data().comments;
        });
      });
  },
  methods: {
      edit() {
        alert('bewerken')
      },
  }
};
</script>